function initLinkedVariants() {
  const dataEl = document.getElementById('linked-variants-data');
  if (!dataEl) return;

  if (!document.getElementById('color-row-gap-style')) {
    const style = document.createElement('style');
    style.id = 'color-row-gap-style';
   style.textContent = `
  .color-row--new { margin-bottom: 36px; }
  .linked-variant-swatch label {
    display: block;
    cursor: pointer;
    transition: outline-color 0.15s ease;
  }
  .linked-variant-swatch:hover label,
  .linked-variant-swatch.active label {
    border-radius: 50%;
    outline-offset: 2px;
    outline-color: currentColor;
  }
  .color-row--new .swatch-items-wrapper,
  .color-row--standard .swatch-items-wrapper { overflow: visible !important; }
  .color-row--new .color-row__label,
  .color-row--standard .color-row__label { margin-bottom: 8px; }

  /* Sold-out overlay for linked swatches — draw the diagonal line directly */
  .linked-variant-swatch.soldout label {
    position: relative;
    overflow: hidden;
  }
  .linked-variant-swatch.soldout label::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(
      to bottom right,
      transparent calc(50% - 0.5px),
      rgba(255,255,255,0.7) calc(50% - 0.5px),
      rgba(255,255,255,0.7) calc(50% + 0.5px),
      transparent calc(50% + 0.5px)
    );
    border-radius: 50%;
    pointer-events: none;
    z-index: 2;
  }
`;
    document.head.appendChild(style);
  }

  const handles = dataEl.dataset.linked
    ? dataEl.dataset.linked.split(',').map(h => h.trim()).filter(Boolean)
    : [];

  const currentHandle = dataEl.dataset.currentHandle || '';

 const newColorIds = new Set(
    (dataEl.dataset.newColors || '').split(',').map(id => id.trim()).filter(Boolean)
  );

  const hiddenVariantIds = new Set(
    (dataEl.dataset.hiddenVariants || '').split(',').map(id => id.trim()).filter(Boolean)
  );

  const bestsellerBadgeIds = new Set(
    (dataEl.dataset.bestsellerBadges || '').split(',').map(id => id.trim()).filter(Boolean)
  );

  const currentProductBestsellerColors = new Set(
    (dataEl.dataset.currentBestsellerColors || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
  );
  

  const currentNewColorNames = new Set();
  document.querySelectorAll('.swatch-element[data-value]:not(.linked-variant-swatch)').forEach(el => {
    const variantId = String(el.dataset.swatchVariantId || '');
    if (newColorIds.has(variantId)) {
      currentNewColorNames.add((el.dataset.value || '').toLowerCase().trim());
    }
  });

  function getNewColorLabel() {
    const lang = document.documentElement.lang || 'de';
    if (lang.startsWith('fr')) return 'NOUVELLE COULEUR';
    if (lang.startsWith('en')) return 'NEW COLOR';
    return 'NEUE FARBE:';
  }

  function getStaticOptionLabel() {
    const productSwatch = document.querySelector('product-swatch.is-color-swatch, product-swatch');
    if (!productSwatch) return 'FARBE';
    const staticLabelEl = productSwatch.querySelector('.header .label-font, .header .linked-option-label');
    if (staticLabelEl) return staticLabelEl.textContent.trim();
    const header = productSwatch.querySelector('.header');
    if (!header) return 'FARBE';
    const clone = header.cloneNode(true);
    clone.querySelectorAll('[data-color-swatch-name], .linked-option-product-title').forEach(el => el.remove());
    return clone.textContent.trim() || 'FARBE';
  }

  function hideThemeColorLabel(productSwatch) {
    const header = productSwatch.querySelector('.header');
    if (header) header.style.display = 'none';
    const colorNameSpan = productSwatch.querySelector('[data-color-swatch-name]');
    if (colorNameSpan) {
      let el = colorNameSpan;
      while (el && el !== productSwatch) {
        const parent = el.parentElement;
        if (!parent || parent === productSwatch) break;
        const significantChildren = Array.from(parent.childNodes).filter(
          n => n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim())
        );
        if (significantChildren.length === 1) { el = parent; } else { break; }
      }
      el.style.display = 'none';
    }
  }

  function restoreThemeColorLabel(productSwatch) {
    const header = productSwatch.querySelector('.header');
    if (header) header.style.display = '';
    const colorNameSpan = productSwatch.querySelector('[data-color-swatch-name]');
    if (colorNameSpan) {
      let el = colorNameSpan;
      while (el && el !== productSwatch) {
        const parent = el.parentElement;
        if (!parent || parent === productSwatch) break;
        const significantChildren = Array.from(parent.childNodes).filter(
          n => n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim())
        );
        if (significantChildren.length === 1) { el = parent; } else { break; }
      }
      el.style.display = '';
    }
  }

  function toHandle(str) {
    return str.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  }

  let cachedResults = null;
  let currentSelectedColor = '';
  let isInternalChange = false;

  function buildDomStyleMap() {
    const map = {};
    document.querySelectorAll('.swatch-element[data-value]:not(.linked-variant-swatch) label').forEach(lbl => {
      const val = lbl.closest('.swatch-element')?.dataset.value || '';
      const style = lbl.getAttribute('style') || '';
      if (val && style) map[val.toLowerCase().trim()] = style;
    });
    return map;
  }

  function isNewColorSwatch(swatchEl) {
    if (swatchEl.dataset.isLinked === 'true') {
      const variantId = String(swatchEl.dataset.linkedVariantId || swatchEl.dataset.swatchVariantId || '');
      return newColorIds.has(variantId);
    }
    return currentNewColorNames.has((swatchEl.dataset.value || '').toLowerCase().trim());
  }

  function isColorInNewRow(colorValue) {
    const colorLower = (colorValue || '').toLowerCase().trim();
    if (currentNewColorNames.has(colorLower)) return true;
    const allNewSwatches = document.querySelectorAll('.color-row--new .swatch-element');
    for (const s of allNewSwatches) {
      if ((s.dataset.value || '').toLowerCase().trim() === colorLower) return true;
    }
    return false;
  }

  function updateRowColorName(selectedColorValue) {
    currentSelectedColor = selectedColorValue || '';
    const newLabelEl = document.querySelector('.color-row--new .color-row__label');
    const stdLabelEl = document.querySelector('.color-row--standard .color-row__label');
    const staticLabel = getStaticOptionLabel();
    const selectedIsNew = isColorInNewRow(currentSelectedColor);
    if (newLabelEl) {
      newLabelEl.textContent = (selectedIsNew && currentSelectedColor)
        ? `${getNewColorLabel()} ${currentSelectedColor}`
        : getNewColorLabel();
    }
    if (stdLabelEl) {
      stdLabelEl.textContent = (!selectedIsNew && currentSelectedColor)
        ? `${staticLabel} ${currentSelectedColor}`
        : staticLabel;
    }
  }

  function buildTwoRowLayout() {
    const productSwatch = document.querySelector('product-swatch.is-color-swatch, product-swatch');
    if (!productSwatch) return;

    const colorSwatchWrapper = productSwatch.querySelector(
      '.swatch-items-wrapper:not(.color-row--new .swatch-items-wrapper):not(.color-row--standard .swatch-items-wrapper)'
    );
    if (!colorSwatchWrapper) return;

    productSwatch.querySelectorAll('.color-row--new, .color-row--standard').forEach(el => el.remove());
    colorSwatchWrapper.style.display = '';

    const allSwatches = Array.from(colorSwatchWrapper.querySelectorAll('.swatch-element'));
    if (!allSwatches.length) return;

    const newSwatches = allSwatches.filter(s => isNewColorSwatch(s));
    const standardSwatches = allSwatches.filter(s => !isNewColorSwatch(s));

    if (!newSwatches.length) {
      restoreThemeColorLabel(productSwatch);
      return;
    }

    hideThemeColorLabel(productSwatch);
    colorSwatchWrapper.style.display = 'none';

    function buildRow(swatches, labelText, rowClass) {
      if (!swatches.length) return null;
      const row = document.createElement('div');
      row.className = rowClass;
      const labelEl = document.createElement('div');
      labelEl.className = 'color-row__label label-font';
      labelEl.textContent = labelText;
      const inner = document.createElement('div');
      inner.className = 'swatch-items-wrapper';
      swatches.forEach(s => inner.appendChild(s));
      row.appendChild(labelEl);
      row.appendChild(inner);
      return row;
    }

    const newRow = buildRow(newSwatches, getNewColorLabel(), 'color-row--new');
    const standardRow = buildRow(standardSwatches, getStaticOptionLabel(), 'color-row--standard');

    if (newRow) colorSwatchWrapper.parentNode.insertBefore(newRow, colorSwatchWrapper);
    if (standardRow) colorSwatchWrapper.parentNode.insertBefore(standardRow, colorSwatchWrapper);

    const currentColorFromTheme = document.querySelector('[data-color-swatch-name]')?.textContent.trim() || '';
    updateRowColorName(currentSelectedColor || currentColorFromTheme);

    productSwatch.querySelectorAll(
      '.color-row--new .swatch-element, .color-row--standard .swatch-element'
    ).forEach(swatchEl => {
      const colorValue = swatchEl.dataset.value || '';
      swatchEl.addEventListener('click', () => setTimeout(() => updateRowColorName(colorValue), 30));
      swatchEl.addEventListener('mouseenter', () => {
        const isInNewRow = swatchEl.closest('.color-row--new') !== null;
        const newLbl = document.querySelector('.color-row--new .color-row__label');
        const stdLbl = document.querySelector('.color-row--standard .color-row__label');
        const staticLabel = getStaticOptionLabel();
        if (newLbl) newLbl.textContent = isInNewRow ? `${getNewColorLabel()} ${colorValue}` : getNewColorLabel();
        if (stdLbl) stdLbl.textContent = !isInNewRow ? `${staticLabel} ${colorValue}` : staticLabel;
      });
      swatchEl.addEventListener('mouseleave', () => updateRowColorName(currentSelectedColor));
    });
  }


  function addBadgesToCurrentProductSwatches() {
    if (!currentProductBestsellerColors.size) return;
    document.querySelectorAll('.swatch-element[data-value]:not(.linked-variant-swatch)').forEach(swatchEl => {
      const colorValue = (swatchEl.dataset.value || '').toLowerCase().trim();
      if (!currentProductBestsellerColors.has(colorValue)) return;
      if (swatchEl.querySelector('.color-swatch-bestseller-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'color-swatch-bestseller-badge';
      badge.innerHTML = 'Best<br>Seller';
      swatchEl.appendChild(badge);
    });
  }


  function injectSwatches(results) {
    const productSwatch = document.querySelector('product-swatch.is-color-swatch, product-swatch');
    if (!productSwatch) return;

    const originalWrapper = productSwatch.querySelector(
      '.swatch-items-wrapper:not(.color-row--new .swatch-items-wrapper):not(.color-row--standard .swatch-items-wrapper)'
    );

    productSwatch.querySelectorAll('.color-row--new, .color-row--standard').forEach(row => {
      if (originalWrapper) {
        row.querySelectorAll('.swatch-element:not(.linked-variant-swatch)').forEach(s => originalWrapper.appendChild(s));
      }
      row.remove();
    });

    restoreThemeColorLabel(productSwatch);

    const colorSwatchWrapper = originalWrapper || productSwatch.querySelector('.swatch-items-wrapper');
    if (!colorSwatchWrapper) return;

    colorSwatchWrapper.style.display = '';
    colorSwatchWrapper.querySelectorAll('.linked-variant-swatch').forEach(el => el.remove());

    const domStyleMap = buildDomStyleMap();

    if (results && results.length) {
      results.forEach(([linkedProduct, swatchStyleMap, isLinkedBack]) => {
  if (!isLinkedBack) return;

        const seenColors = [];

        linkedProduct.variants.forEach(variant => {
          if (hiddenVariantIds.has(String(variant.id))) return;

          const colorValue = variant.option1 || variant.title;
          if (seenColors.includes(colorValue)) return;

          const allVariantsOfColorHidden = linkedProduct.variants
  .filter(v => v.option1 === colorValue)
  .every(v => hiddenVariantIds.has(String(v.id)));
if (allVariantsOfColorHidden) return;

// Market visibility check for linked swatches
const currentMarket = document.documentElement.dataset.market || 
  window.__market || 
  (document.cookie.match(/market=([^;]+)/) || [])[1] || '';

          seenColors.push(colorValue);

          const colorKey = colorValue.toLowerCase().trim();
          const colorHandle = toHandle(colorValue);

          const isAvailable = linkedProduct.variants
            .filter(v => v.option1 === colorValue && !hiddenVariantIds.has(String(v.id)))
            .some(v => v.available);

          const firstVisibleVariant = linkedProduct.variants.find(
            v => v.option1 === colorValue && !hiddenVariantIds.has(String(v.id))
          );
          if (!firstVisibleVariant) return;

          const swatchEl = document.createElement('div');
swatchEl.className = `swatch-element variant-swatch color linked-variant-swatch ${isAvailable ? 'available' : 'soldout'}`;
swatchEl.dataset.swatchOptionAvailable = String(isAvailable);
swatchEl.dataset.swatchVariantId = String(firstVisibleVariant.id);
swatchEl.dataset.linkedAvailable = String(isAvailable); // guard against theme overwrite
          swatchEl.dataset.option = 'Farbe';
          swatchEl.dataset.value = colorValue;
          swatchEl.dataset.linkedHandle = linkedProduct.handle;
          swatchEl.dataset.linkedVariantId = firstVisibleVariant.id;
          swatchEl.dataset.isLinked = 'true';

          const label = document.createElement('label');
          label.setAttribute('title', colorValue);

          if (swatchStyleMap[colorKey]) {
            label.setAttribute('style', swatchStyleMap[colorKey]);
          } else if (domStyleMap[colorKey]) {
            label.setAttribute('style', domStyleMap[colorKey]);
          } else {
            label.style.backgroundColor = '#ccc';
            const extensions = ['png', 'jpg', 'jpeg'];
            let loaded = false;
            extensions.forEach(ext => {
              if (loaded) return;
              const url = `/cdn/shop/files/${colorHandle}.${ext}`;
              const img = new Image();
              img.onload = () => {
                if (!loaded) {
                  loaded = true;
                  label.style.backgroundImage = `url(${img.src})`;
                  label.style.backgroundSize = 'cover';
                  label.style.backgroundPosition = 'center center';
                  label.style.backgroundColor = '';
                }
              };
              img.src = url;
            });
          }

          const soldOutBg = document.createElement('span');
          soldOutBg.className = 'product-swatch-sold-out product-swatch-sold-out-background';
          const soldOutFg = document.createElement('span');
          soldOutFg.className = 'product-swatch-sold-out product-swatch-sold-out-foreground';
          const srOnly = document.createElement('span');
          srOnly.className = 'sr-only';
          srOnly.textContent = colorValue;

          label.appendChild(srOnly);
label.appendChild(soldOutBg);
label.appendChild(soldOutFg);

if (bestsellerBadgeIds.has(String(firstVisibleVariant.id))) {
  const badge = document.createElement('span');
  badge.className = 'color-swatch-bestseller-badge';
  badge.innerHTML = 'Best<br>Seller';
  label.appendChild(badge);
}

swatchEl.appendChild(label);



          swatchEl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = `/products/${linkedProduct.handle}?variant=${firstVisibleVariant.id}`;
          });

          swatchEl.addEventListener('mouseenter', function () {
  const nameEl = document.querySelector('[data-color-swatch-name]');
  if (nameEl) {
    nameEl.dataset.originalName = nameEl.dataset.originalName || nameEl.textContent;
    nameEl.textContent = colorValue;
  }
  const stateEl = document.querySelector('[data-color-swatch-state]');
  if (stateEl) {
    stateEl.dataset.originalState = stateEl.dataset.originalState !== undefined
      ? stateEl.dataset.originalState
      : stateEl.textContent;
    if (!isAvailable) {
  const productSwatch = document.querySelector('product-swatch');
  const soldOutString = productSwatch?.dataset.swatchSoldOutString || 'Ausverkauft';
  stateEl.textContent = `(${soldOutString})`;
} else {
  stateEl.textContent = '';
}
  }
});

swatchEl.addEventListener('mouseleave', function () {
  const nameEl = document.querySelector('[data-color-swatch-name]');
  if (nameEl && nameEl.dataset.originalName) {
    nameEl.textContent = nameEl.dataset.originalName;
    delete nameEl.dataset.originalName;
  }
  const stateEl = document.querySelector('[data-color-swatch-state]');
  if (stateEl && stateEl.dataset.originalState !== undefined) {
    stateEl.textContent = stateEl.dataset.originalState;
    delete stateEl.dataset.originalState;
  }
});

          colorSwatchWrapper.appendChild(swatchEl);
        });
      });
    }

   addBadgesToCurrentProductSwatches();
    buildTwoRowLayout();
    document.dispatchEvent(new CustomEvent('linked-variants:injected'));
  }

 function setupObserver() {
    const observerTarget = document.querySelector('[data-product-options]') ||
                           document.querySelector('product-swatch')?.closest('[data-updates-on-change]') ||
                           document.querySelector('.product--add-to-cart-form');

    if (!observerTarget) return;

    let debounceTimer = null;

    const observer = new MutationObserver(() => {
      if (document.querySelector('.linked-variant-swatch')) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (cachedResults) {
          injectSwatches(cachedResults);
        } else {
          addBadgesToCurrentProductSwatches();
          buildTwoRowLayout();
        }
      document.dispatchEvent(new CustomEvent('linked-variants:injected'));
      }, 150);
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
  }

  if (!handles.length) {
    addBadgesToCurrentProductSwatches();
    buildTwoRowLayout();
    setupObserver();
    return;
  }

  Promise.all(
    handles.map(handle =>
      Promise.all([
        fetch(`/products/${handle}.js`).then(r => r.json()),
        (() => {
          const cacheKey = `lv_html_${handle}`;
          const cached = sessionStorage.getItem(cacheKey);
          if (cached) return Promise.resolve(cached);
          return fetch(`/products/${handle}`, { cache: 'force-cache' })
            .then(r => r.text())
            .then(html => { try { sessionStorage.setItem(cacheKey, html); } catch(e) {} return html; })
            .catch(() => '');
        })()
      ])
    )
  ).then(results => {
    cachedResults = results.map(([linkedProduct, pageHtml]) => {
      let isLinkedBack = false;
      const swatchStyleMap = {};

      if (pageHtml && currentHandle) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(pageHtml, 'text/html');

  const linkedDataEl = doc.getElementById('linked-variants-data');
  if (linkedDataEl) {
    const linkedBackHandles = (linkedDataEl.dataset.linked || '')
      .split(',').map(h => h.trim().toLowerCase()).filter(Boolean);
    
    // Check if current product is in linked product's list
    // OR if linked product is in current product's list (one-way is enough)
    const currentDataEl = document.getElementById('linked-variants-data');
    const currentLinkedHandles = currentDataEl 
      ? (currentDataEl.dataset.linked || '').split(',').map(h => h.trim().toLowerCase()).filter(Boolean)
      : [];
    
    isLinkedBack = linkedBackHandles.includes(currentHandle.toLowerCase()) ||
                   currentLinkedHandles.includes(linkedProduct.handle.toLowerCase());

    const linkedNewColors = (linkedDataEl.dataset.newColors || '')
      .split(',').map(id => id.trim()).filter(Boolean);
    linkedNewColors.forEach(id => newColorIds.add(id));
  }

        doc.querySelectorAll('.swatch-element[data-value] label').forEach(lbl => {
          const val = lbl.closest('.swatch-element')?.dataset.value || '';
          const style = lbl.getAttribute('style') || '';
          if (val && style) swatchStyleMap[val.toLowerCase().trim()] = style;
        });
      }

      return [linkedProduct, swatchStyleMap, isLinkedBack];
    });

    injectSwatches(cachedResults);
    setupObserver();
  }).catch(err => {
    console.error('[linked-variants] Error:', err);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLinkedVariants);
} else {
  initLinkedVariants();
}